import React from 'react';
import {connect} from "src/store";
import Icon from "../form/Icon";
import {setContent} from "../../actions";
import {sendRequest} from "../../utils/request";
import parse_url from "locutus/php/url/parse_url";
import parse_str from "locutus/php/strings/parse_str";
import {Tooltip} from "react-tippy";
import moment from "moment";
import debounce from "lodash-es/debounce";

const currentScript = document.currentScript;

let currentVersion = parse_url(currentScript.getAttribute('src'));

parse_str(currentVersion.query || "", currentVersion);
currentVersion = currentVersion.v || null;
let nextVersion = currentVersion;
let currentDate = moment();

let request;

class MainReleaseInfoMenu extends React.Component {
    
    state = {
        currentVersion,
        nextVersion,
        currentDate,
    }

    constructor(props) {
        super(props);
        this.onMouseMove = debounce(() => {
            if (moment().diff(this.state.currentDate, 'minutes', true) > 5) {
                this.checkVersion();
            }
        }, 300);
    }


    componentDidMount() {
        window.addEventListener("focus", this.onFocus);
        window.addEventListener("blur", this.onBlur);
        window.addEventListener("mousemove", this.onMouseMove);
    }

    componentWillUnmount() {
        window.removeEventListener("focus", this.onFocus);
        window.removeEventListener("blur", this.onBlur);
        window.removeEventListener("mousemove", this.onMouseMove);
    }

    onFocus = () => {
        this.checkVersion();
    }

    onBlur = () => {
        this.checkVersion();
    }

    checkVersion = () => {
        if (!window.envBooqadmin.debug) {
            request ??= sendRequest({}, {headers: false, url: window.location.href}).then((data) => {
                const el = document.createElement('html');
                el.innerHTML = data;
                const url = parse_url(currentScript.getAttribute('src'));
                const scriptTag = el.querySelector('script[src*="' + url.path.slice(1) + '"]');
                if (scriptTag) {
                    nextVersion = parse_url(scriptTag.getAttribute("src"));
                    parse_str(nextVersion.query || "", nextVersion);
                    nextVersion = nextVersion.v || null;
                    this.setState({nextVersion, currentDate: moment()});
                }
                request = null;
            });
        }
    }

    render() {
        return this.state.currentVersion !== this.state.nextVersion && <li className="blob red">
            <Tooltip title="Új verzió érhető el, a frissítéshez kattints!">
                <a href="#" onClick={(e) => {
                    e && e.preventDefault();
                    window.location.reload(true);
                }}>
                    <Icon lib="fas" name="code-branch" />
                    <span className="label label-danger">!</span>
                </a>
            </Tooltip>
        </li>;
    }
}

const ConnectedMainReleaseInfoMenu = connect((state) => ({values: ((state.editors.ReleaseInfo || {}).values || {})}), {setContent})(MainReleaseInfoMenu);

export default ConnectedMainReleaseInfoMenu;